// extracted by mini-css-extract-plugin
export default {"textholder":"DonatonWidget_textholder__c-7yV"};